// extracted by mini-css-extract-plugin
export default {"header":"style_header__a8KqI","title":"style_title__K9nV1","rightSide":"style_rightSide__7ZPJa"};